import { useContext } from "react";
import { Outlet } from "react-router-dom";

import Navbar from "../components/Navbar/Navbar";
import Sidebar from "../components/Sidebar/Sidebar";

import styles from "./AppLayout.module.css"
import { AuthContext } from "../context/AuthContext";
import { BrandLoader } from "../components/Brand";
import usePageTitle from "../hooks/usePageTitle";

function AppLayout() {

    const { ready } = useContext(AuthContext);
    
    // Update page title based on current route
    usePageTitle();

    if (ready === false) {
        return <BrandLoader />;
    }

    return (
        <div className={styles["layout-container"]}>
            <Navbar />
            <div className={styles["layout-body"]}>
                <Sidebar isCollapsed />
                <div className={styles["layout-content"]}>
                    <div className={styles["layout-main"]}>
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AppLayout;
